import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import { useSetting } from '../../util/useSetting';
import PreviousSvg from '../../svg/student/Previous.js';
import NextSvg from '../../svg/student/Next.js';
import ReloadSvg from '../../svg/student/Reload.js';

const RESEARCHES = [
    {
        id: '香港學生睡眠',
        name: '香港學生睡眠',
        image: '/secondary/tasks/r1.png',
        subtitle: '研究測試 1'
    },
    {
        id: '機器人',
        name: '機器人',
        image: '/secondary/tasks/r2.png',
        subtitle: '研究測試 2'
    },
]



function Component(props) {
    const { id } = useParams();
    const navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();
    const [data, setdata] = useState(RESEARCHES.filter(item => item.id === id)?.[0])
    const [isLoading, setisLoading] = useState(false)
    const { fontSize } = useSetting();




    const fetchData = async (force = false) => {
        if (isLoading && !force) return
        setisLoading(true)
        const filter = {}
        // if (status !== '全部') filter.status = status
        // let result = await fetchSchoolMissions(props.token.token, filter, { limit, skip: (page - 1) * limit });
        // if (result.result) {
        //     setdata(result.result)
        //     settotal(result.count || 0)
        // } else {
        //     alert('Fetch data error')
        // }
        setisLoading(false)
    }



    useEffect(() => {
        const timer = setTimeout(fetchData, 500)
        // const interval = setInterval(fetchData,1000*30)
        return () => {
            clearTimeout(timer)
            // clearInterval(interval)
        }
    }, [searchParams])


    const [isDoingShortTask, setisDoingShortTask] = useState(true)


    return (
        <div className='h-full flex-1 bg-[#EDF5F8] flex-col flex gap-[16px]' style={{ fontSize }}>

            {isDoingShortTask && <ShortTask />}

            {isLoading && <LoadingPage />}
        </div>
    );
}

const SHORT_TASK_QUESTIONS = [
    {
        id: 0,
        type: '圖片',
        image: '/secondary/tasks/rp1.png'
    },
    {
        id: 1,
        type: '選擇題',
        text: '1.<br/>「生茄子嘗起來就像一顆平淡無味的蘋果，但一經烹調，便搖身變為可口無比的珍饈。酥炸過的茄子會散發美妙的奶油香味，灑些甜中帶辣的香料，風味絕佳。無論是燉煮或烘烤，茄子那種菇蕈般的麝香氣味，都能與鹹味食材完美搭配。除了偷偷咬一小口的方式外，檢查茄子是否具有所需風味與質地最好的方法，就是測試它的緊實度。一顆理想的茄子，外觀應該要像海豚皮膚般緊實光亮，用手揉捏時，還會發出嘎吱嘎吱的聲響。」',
        question: '根據本文，下列關於茄子的風味介紹，何者在文中沒有被提及？',
        options: [
            { text: 'A. 食用口感', },
            { text: 'B. 調味搭配', },
            { text: 'C. 適用醬汁', },
            { text: 'D. 測試方式', },
        ],
        backgroundImage: '/secondary/tasks/rp2.png'
    }, {
        id: 2,
        type: '選擇題',
        text: '2.<br/>「每個人都會在人世中遭遇一些坎坷，我們的身心都可能傷痕累累，但，那也是我們學習的功課。」',
        question: '作者這段文字的意義最接近下列何者?',
        options: [
            { text: 'A. 因為人世中總會遇到一些坎坷，所以身心受創是無法避免的。', },
            { text: 'B. 唯有精進學業，才能以堅毅的心迎戰人世中不可預期的坎坷。', },
            { text: 'C. 雖然人生的坎坷境遇會打擊我們，卻也是我們要面對的挑戰。', },
            { text: 'D. 即便作好萬全準備，遭遇坎坷時仍會給身心帶來巨大的傷害。', },
        ],
        background: '#F8FAFB'

    }, {
        id: 3,
        type: '選擇題',
        text: '3.<br/>「一個項目成功與否，有 60%以上的因素取決於是否能以數行到一頁之間的長度陳述其核心想法，這也是所有業界人士是否願意青睞，考慮要不要繼續看下去的關鍵。」',
        question: '根據本段文字，推論業界人士最需要的是哪一項能力？',
        options: [
            { text: 'A. 高效搜集和整理大量資料的技巧' },
            { text: 'B. 簡潔與精准表達中心觀點的能力' },
            { text: 'C. 快速撰寫與解讀長篇文章的技能' },
            { text: 'D. 具備創意思維和問題解決的能力' },
        ],
        backgroundImage: '/secondary/tasks/rp3.png'
    }, {
        id: 4,
        type: '選擇題',
        text: '4.<br/>「王先生是一位享譽國際的畫家，正忙著準備今天的演講稿。去年，他再度榮獲世界繪畫大獎，讓他躍上了事業巔峰。其實，他並非從小就展現繪畫天分，他曾在課堂上多次被老師訓斥。想起那段往事後，王先生微微一笑，拿起筆，繼續修改眼前的講稿。」',
        question: '關於這段文字的寫作結構，下列分析何者正確?',
        options: [
            { text: 'A. 全文依照時間發生的先後，一步步交代王先生的奮鬥過程。' },
            { text: 'B. 採用倒敘法，先寫王先生事業成功，再說明他成名的原因。' },
            { text: 'C. 文末補充王先生微微一笑，是為了讓讀者掌握主角的心境，屬補敘法。' },
            { text: 'D. 在敘述當下準備演講的過程中，暫時切入小時候的往事，屬於插敘法。' }
        ],
        background: '#F8FAFB'
    }
]

function ShortTask(props) {
    const { fontSize } = useSetting();
    const [questions, setQuestions] = useState(SHORT_TASK_QUESTIONS)
    return (
        <div className='w-full flex flex-col h-full' style={{ fontSize }}>

            <div className='w-full flex flex-row justify-start gap-[8px] mt-[16px] px-[16px] font-[900]'>
                <button className='px-[18px] py-[4px] rounded-full flex flex-row items-center text-[white] gap-[8px] noto-san-hk font-[600]' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1)' }}>
                    <img src='/secondary/setting.png' alt='設定' />
                    設定
                </button>
                <div className='flex flex-row gap-[8px] flex-1 justify-end'>
                    <button>
                        <img src='/secondary/btn1.png' />
                    </button>
                    <button>
                        <img src='/secondary/btn2.png' />
                    </button>
                    <button>
                        <img src='/secondary/btn3.png' />
                    </button>
                </div>


            </div>
            <div className='w-full flex flex-row justify-start gap-[8px] mt-[16px] px-[16px] font-[900]'>
                <button
                    className='flex-1 max-w-[220px] overflow-hidden text-ellipsis whitespace-nowrap text-center py-[4px]'
                    style={true ? { background: 'linear-gradient(to left, #108B96, #003A57)', color: 'white', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' } : { background: 'linear-gradient(to bottom, #ccc, #fff)', color: '#003A57', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}
                    onClick={() => { }}
                >
                    短篇閱讀
                </button>
            </div>
            <div className='w-full flex flex-row bg-[white] items-center' style={{ borderBottom: '1px solid #E3E3E3', marginTop: 4, gap: 6, padding: 6 }}>
                <div className='cursor-pointer'>
                    <PreviousSvg height={30} width={30} />
                </div>
                <div className='cursor-pointer'>
                    <NextSvg height={30} width={30} />
                </div>
                <div className='cursor-pointer'>
                    <ReloadSvg height={30} width={30} />
                </div>
                <div className='flex-1'>
                    <input disabled={true} className='w-full text-[black] bg-[#EEF2F6] rounded-[4px]' value={'https://task1.com'} style={{ fontSize: fontSize - 4, height: 40, paddingLeft: 24, paddingRight: 24 }} />
                </div>
            </div>

            <div className='w-full flex flex-col items-center flex-1 overflow-auto noto-san-hk'>
                {questions?.map((question, qi) =>

                    <div key={qi} className='w-full flex flex-col items-start'>
                        {question.type === '圖片' ?
                            <div className='w-full'>
                                <img src={question.image} alt='' className='w-full' />
                            </div>
                            : question.type === '選擇題' ?
                                <div className='w-full flex flex-col relative font-bold' style={{ background: question.background || 'none' }}>
                                    {question.backgroundImage && <img className='w-full z-[1]' src={question.backgroundImage} alt='' style={{ objectFit: 'contain' }} />}
                                    <div className={question.backgroundImage ? 'inset-0 absolute z-[2] flex flex-col px-[15%] justify-center items-start' : 'flex flex-col w-full px-[15%] justify-center items-start py-[64px]'}>
                                        <div className='w-full text-[black] mb-[24px] font-[900]' dangerouslySetInnerHTML={{ __html: question.text }} />
                                        <div className='w-full text-[black] mb-[24px]'>{question.question}</div>
                                        <div className='w-full flex flex-col gap-[4px]'>
                                            {question.options.map((option, oi) =>
                                                <div key={oi} className='w-full text-[black] flex flex-row items-center gap-[16px]'>
                                                    <button className='w-[20px] h-[20px] border border-[#005B8C] rounded-full flex-shrink-0' style={{ backgroundColor: option.selected ? '#005B8C' : 'transparent' }} onClick={
                                                        () => {
                                                            let newQuestions = [...questions]
                                                            for (let op of newQuestions[qi].options) {
                                                                op.selected = false
                                                            }
                                                            newQuestions[qi].options[oi].selected = true
                                                            setQuestions(newQuestions)

                                                        }
                                                    }>

                                                    </button>
                                                    {option.text}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                : null}

                    </div>
                )}
            </div>
            <div className='flex flex-row justify-center bg-[#F8FAFB] py-[32px]'>
                <button onClick={() => { }} className='text-[#007A83] font-bold mb-[6px] mr-[8px] noto-san-hk text-white p-[2px] rounded-full' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to left, #015B6B, #00E9BA)' }}>
                    <div className='rounded-full px-[48px] py-[6px] ' style={{ border: '2px solid #eee', background: 'linear-gradient(to right, #015B6B, #00E9BA)' }}>
                        提交並進入閱讀任務
                    </div>
                </button>
            </div>
        </div>
    )
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
